var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"button stackng-button",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.openModal()}}},[_c('ion-icon',{staticClass:"button-icon",attrs:{"name":"ios-contacts"}}),_vm._v(" \n\t\tCreate new group\n\t")],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-282e69a1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/buttons/NewGroupButton.vue
// module id = null
// module chunks = 